import {ComponentType, CSSProperties, HTMLAttributes, memo} from 'react';
import {SvgImage} from '@ui/images/svg-image';
import {SvgIconProps} from '@ui/icons/svg-icon';
import {isAbsoluteUrl} from '@ui/utils/urls/is-absolute-url';
import {normalizeStorageUrl} from '@ui/utils/urls/normalize-storage-url';

interface Props extends HTMLAttributes<HTMLElement> {
  src: string | ComponentType<SvgIconProps>;
  className?: string;
  cssProp?: CSSProperties;
}
export const MixedImage = memo(({src, className, cssProp, ...domProps}: Props) => {
  const normalizedSrc =
    typeof src === 'string' ? normalizeStorageUrl(src) : src;
  let type: 'svg' | 'image' | 'icon' | null = null;

  if (!normalizedSrc) {
    type = null;
  } else if (typeof normalizedSrc === 'object') {
    type = 'icon';
  } else if (
    (normalizedSrc as string).endsWith('.svg') &&
    !isAbsoluteUrl(normalizedSrc as string)
  ) {
    type = 'svg';
  } else {
    type = 'image';
  }

  if (type === 'svg') {
    return (
      <SvgImage
        {...domProps}
        className={className}
        src={normalizedSrc as string}
        height={false}
      />
    );
  }

  if (type === 'image') {
    return (
      <img
        {...domProps}
        style={cssProp}
        className={className}
        src={normalizedSrc as string}
        alt=""
      />
    );
  }

  if (type === 'icon') {
    const Icon = normalizedSrc;
    return (
      <Icon
        {...(domProps as HTMLAttributes<SVGElement>)}
        className={className}
      />
    );
  }

  return null;
});
